/*
  Функция для определния того, что узел является кастомным компонентом
*/
export function isCompositeComponent(node) {
  return !!node && typeof node.type === 'function';
}